export default __webpack_public_path__ + "static/media/pantry1-afterD-2048w.45e44d88.avif";